import { fetchFront } from "../../services/front";
import { action, thunk } from "easy-peasy";

export const frontModel = {
  front: {
    // stores: 110,
    // employee:50,
    // city:20,
    // settlements:30
  },
  error: null,
  setError: action((state, payload) => {
    state.error = payload;
  }),
  setFront: action((state, payload) => {
    state.front = payload;
  }),
  getFront: thunk(async (actions, payload) => {
    try {
      const request = await fetchFront();
      if (request && !request.error) {
        actions.setFront(request);
      }
    } catch (err) {
      actions.setError(err);
    }
  }),
};
